import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import { format } from "date-fns";
import $ from "jquery";
import Axios from "axios";
import Select from "react-select";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GET_GLOBAL_SETTINGS, GET_STATICBLOCK_LIST } from "../../actions";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
/* import wishlist from "../../common/images/img/wishlist.svg"; */
import profile from "../../common/images/img/profile.svg";
import cartbag from "../../common/images/img/cart-bag.svg";
import mapicon from "../../common/images/map-icon.svg";
/* import time from "../../common/images/time-quarter.svg"; */
import cycle from "../../common/images/cycle.svg";
import navb from "../../common/images/img/nav-icon.svg";
import closei from "../../common/images/img/close-top.svg";
import susteirewards from "../../common/images/img/ascentis.png";
import menuicon from "../../common/images/menu-icon.svg";
import { ReactComponent as TimeIcon } from "../../common/images/time-quarter.svg";
import ShopImg from "../../common/images/shop.png";
import takeawayImg from "../../common/images/takeaway-w.png";


import Cart from "./Cart";
import {
  showLoader,
  hideLoader,
  getReferenceID,
} from "../Settings/SettingHelper";
import {
  uniqueID,
  apiUrl,
  deliveryId,
  themeClass,
  siteLogo,
  companyName,
  termsEmail,
  termsEmailLink,
  mainUrl,
  menuPage,
  appName
} from "../Settings/Config";
import AvilablityPopup from "./AvilablityPopup";
import OmisePayment from "../Module/OmisePayment";
import country from "../../common/json/country.json";
let countryList = [];
country.forEach((element) => {
  countryList.push({ label: element.name, value: element.name });
});
const base64 = require("base-64");
class Header extends Component {
  constructor(props) {
    super(props);
    console.log(this.props, "propspropsprops");
    const customerID = localStorage.getItem("customerID") ?? "";
    const orderDateTime = cookie.load("orderDateTime") ?? "";
    const displyDate =
      orderDateTime !== ""
        ? format(new Date(orderDateTime.replaceAll('"', "")), "do MMM yyyy")
        : "";
    const displyTime =
      orderDateTime !== ""
        ? format(new Date(orderDateTime.replaceAll('"', "")), "hh:mm a")
        : "";
    const seletedAvilablityId = cookie.load("availability") ?? "";
    const seletedAvilablityName = cookie.load("availabilityName") ?? "";
    const slotType = cookie.load("slotType") ?? "";
    const outletID = cookie.load("outletID") ?? "";
    let maxdate = new Date();
    maxdate.setFullYear(maxdate.getFullYear() - 10);
    this.state = {
      customerID: customerID,
      outletID: outletID,
      seletedAvilablityId: seletedAvilablityId,
      seletedAvilablityName: seletedAvilablityName,
      trigerCart: this.props?.trigerCart ?? false,
      openCart: false,
      totalItem: 0,
      openPopup: false,
      loginopenPopup: false,
      popupType: "guestlogin",
      email: "",
      emailError: "",
      loginpassword: "",
      loginpasswordError: "",
      loginconfirmpassword:"",
      loginconfirmpasswordError:"",
      existCustomer: false,
      otpType:"Login",
      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      otp5: "",
      otp6: "",

      maxdate: maxdate,
      firstName: "",
      lastName: "",
      mobile: "",
      otp: "",
      otpError: "",
      password: "",
      passwordError: "",
      cpassword: "",
      cpasswordError: "",
      gender: "",
      genderError: "",
      birthdate: "",
      birthdateError: "",
      nationality: "",
      nationalityError: "",
      referrerCode: "",
      verifiedOTP: false,
      allowEnterOTP: false,
      showGetOTP: true,
      showResendOTP: false,
      showCount: false,
      countTime: 120,

      terms: false,
      allowPromotion: false,

      firstNameError: "",
      lastNameError: "",
      mobileError: "",
      termsError: "",
      allowPromotionError: "",

      displyDate: displyDate,
      displyTime: displyTime,

      openAvailPopup: this.props?.openAvailPopup ?? false,
      allowOpenCart: false,
      reloadCartPage: false,

      slotType: slotType,
      orderSlotEndTime: "",
      orderSlotStrTime: "",
      allowDefaultAvilablity: "",
      allowDefaultAvilablityName: "",
      globalSettings: "",

      enableOmise: false,
      openomisePopup: false,
      membershipAmount: 60,
      omiseKey: "",
      omise_envir: "",
      ascentisloginopenPopup: false,
      ascentissignupopenPopup: false,
      enableAscentisCRM: false,
    };

    this.otp1Ref = React.createRef();
    this.otp2Ref = React.createRef();
    this.otp3Ref = React.createRef();
    this.otp4Ref = React.createRef();
    this.otp5Ref = React.createRef();
    this.otp6Ref = React.createRef();
    this.handleChangeDate = this.handleChangeDate.bind(this);
  }
  componentDidMount() {
    document.body.classList.add(themeClass);
    document.body.classList.remove("nav-active");
    setTimeout(() => {
      $("body").css("overflow", "scroll !important");
    }, 1000);
    window.scrollTo({ top: 0, behavior: "smooth" });

    const triggerLogin = cookie.load("triggerLogin") ?? "";

    if (triggerLogin === "Yes") {
      cookie.remove("triggerLogin", { path: "/" });
      this.setState({ loginopenPopup: true, popupType: "guestlogin" });
      cookie.remove("triggerLogin", { path: "/" });
    }
    const triggerOrderType = cookie.load("triggerOrderType") ?? "";
    if (triggerOrderType === "Yes") {
      cookie.remove("triggerOrderType", { path: "/" });
      this.setState({ openAvailPopup: true });
    }

    let startTime = new Date();
    if (parseInt(this.state.slotType) === 2) {
      const orderSlotStrTime = cookie.load("orderSlotStrTime") ?? "";
      if (orderSlotStrTime !== "") {
        const orderSlotStrTime_ = orderSlotStrTime.split(":");
        startTime.setHours(orderSlotStrTime_[0]);
        startTime.setMinutes(orderSlotStrTime_[1]);
        this.setState({ orderSlotStrTime: format(startTime, "hh:mm a") });
      }
    }

    let endTime = new Date();

    if (parseInt(this.state.slotType) === 2) {
      const orderSlotEndTime = cookie.load("orderSlotEndTime") ?? "";
      if (orderSlotEndTime !== "") {
        const orderSlotEndTime_ = orderSlotEndTime.split(":");
        endTime.setHours(orderSlotEndTime_[0]);
        endTime.setMinutes(orderSlotEndTime_[1]);
        this.setState({ orderSlotEndTime: format(endTime, "hh:mm a") });
      }
    }
    this.props.getSettingDetail();
    this.props.getStaticBlock();

    const tiggerOTP = cookie.load('tiggerOTP') ?? '';
    if(tiggerOTP==="Yes") {
     // this.sendVerifyMysscountOTP();      
    }
  }
  componentWillReceiveProps(PropsDt) {
    if (this.state.trigerCart !== PropsDt.trigerCart) {
      this.setState({ trigerCart: PropsDt.trigerCart }, function () {
        this.props.updateStateValue("trigerCart", PropsDt.trigerCart);
      });
    }
    let loginopenPopup = PropsDt?.loginopenPopup ?? '';
    if(loginopenPopup!=="") {
      if(this.state.loginopenPopup!==loginopenPopup) {
        if(appName==='sushitei') {
          this.setState({loginopenPopup:loginopenPopup, popupType: "ascentislogin"})
        }else {
          this.setState({loginopenPopup:loginopenPopup, popupType: "guestregister"})
        }        
      }
    }
    if (this.state.trigerCart !== PropsDt.trigerCart) {
    }

    if (this.state.openAvailPopup !== PropsDt.openAvailPopup) {
      this.setState({ openAvailPopup: PropsDt.openAvailPopup });
    }
    if (this.state.allowDefaultAvilablity !== PropsDt.allowDefaultAvilablity) {
      this.setState({
        allowDefaultAvilablity: PropsDt.allowDefaultAvilablity,
        allowDefaultAvilablityName: PropsDt.allowDefaultAvilablityName,
      });
    }
    if (this.state.globalSettings !== PropsDt.globalSettings) {
      const settingsArr = PropsDt.globalSettings;
      const enableOmise = settingsArr?.companyEnableOmise ?? false;
      const companyOmisePublicKey = settingsArr?.companyOmisePublicKey ?? "";
      const omiseKey = companyOmisePublicKey !== "" ? base64.decode(companyOmisePublicKey) : "";
      this.setState({
        globalSettings: PropsDt.globalSettings,
        enableOmise,
        omiseKey,
        omise_envir: "dev",
        enableAscentisCRM:settingsArr?.companyEnableAscentisCRM ?? false
      });
    }

    /* if(this.state.loginopenPopup!==PropsDt.loginPopup) {
      alert(this.state.loginopenPopup)
      alert()
      this.setState({loginopenPopup:PropsDt.loginPopup})
    } */
  }
  sendVerifyMysscountOTP() {
    const postObject = {
      uniqueID,
     };
      Axios.post(`${apiUrl}customer/send-myaccount-otp`, postObject, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }).then((res) => {
        if (res.data.status === "ok") {
          this.setState({loginopenPopup:true, popupType:"otpverify"})
        }
      }).catch((e) => {
        var errorMsg = e?.response?.data?.message || e.message;
        toast.error(errorMsg);
      });
  }
  openCart(e) {
    e.preventDefault();
    if (this.props.match.path !== "/checkout") {
      if (parseInt(this.state.totalItem) > 0) {
        if (this.state.seletedAvilablityId !== "") {
          this.setState({ openCart: true });
          document.body.classList.add("cart-sidebar-open");
        } else {
          this.props.updateStateValue("openAvailPopup", true);
          this.setState({ allowOpenCart: true, openAvailPopup: true });
        }
      }
    }
  }
  updateStateValueNew = (field, value) => {
  }
  updateStateValue = (field, value) => {
    this.setState({ [field]: value }, () => {
      if (field === "trigerCart") {
        this.props.updateStateValue("trigerCart", value);
      } else if (field === "openPopup") {
        this.props.updateStateValue("openAvailPopup", value);
      } else if (field === "allowDefaultAvilablity") {
        this.props.updateStateValue("allowDefaultAvilablity", value);
      } else if (field === "reloadCartPage") {
        const customerID_ = localStorage.getItem("customerID") ?? "";
        const orderDateTime_ = cookie.load("orderDateTime") ?? "";
        const displyDate_ =
          orderDateTime_ !== ""
            ? format(
                new Date(orderDateTime_.replaceAll('"', "")),
                "do MMM yyyy"
              )
            : "";
        const displyTime_ =
          orderDateTime_ !== ""
            ? format(new Date(orderDateTime_.replaceAll('"', "")), "hh:mm a")
            : "";
        const seletedAvilablityId_ = cookie.load("availability") ?? "";
        const seletedAvilablityName_ = cookie.load("availabilityName") ?? "";
        const slotType_ = cookie.load("slotType") ?? "";
        this.setState({
          customerID: customerID_,
          seletedAvilablityId: seletedAvilablityId_,
          seletedAvilablityName: seletedAvilablityName_,
          displyDate: displyDate_,
          displyTime: displyTime_,
          slotType: slotType_,
        });

        let endTime = new Date();
        const orderSlotEndTime = cookie.load("orderSlotEndTime") ?? "";
        if (orderSlotEndTime !== "") {
          const orderSlotEndTime_ = orderSlotEndTime.split(":");
          endTime.setHours(orderSlotEndTime_[0]);
          endTime.setMinutes(orderSlotEndTime_[1]);
          this.setState({ orderSlotEndTime: format(endTime, "hh:mm a") });
        }

        let startTime = new Date();
        const orderSlotStrTime = cookie.load("orderSlotStrTime") ?? "";
        if (orderSlotStrTime !== "") {
          const orderSlotStrTime_ = orderSlotStrTime.split(":");
          startTime.setHours(orderSlotStrTime_[0]);
          startTime.setMinutes(orderSlotStrTime_[1]);
          this.setState({ orderSlotStrTime: format(startTime, "hh:mm a") });
        }
      } else if (field === "totalItem") {
        this.setState({ totalItem: value });
      }
    });
  };
  openLogin(e) {
    e.preventDefault();
    if (this.state.customerID !== "") {
      this.props.history.push("/myprofile");
    } else {
      if(this.state.enableAscentisCRM) {
        this.setState({ ascentisloginopenPopup: true });
      }else {
        this.setState({ loginopenPopup: true });
      }
      
    }
  }
  handleChange(name, e) {
    const value = e.target.value;

    if (name.indexOf("otp") >= 0) {
      this.setState({ [name]: "" }, () => {
        this.setState({ [name]: value, [`${name}Error`]: "" });
      });
      var lastFive = name.slice(-1);

      if (lastFive === "1") {
        if (value === "") {
          this.otp1Ref.current?.focus();
        } else {
          this.otp2Ref.current?.focus();
        }
      } else if (lastFive === "2") {
        if (value === "") {
          this.otp1Ref.current?.focus();
        } else {
          this.otp3Ref.current?.focus();
        }
      } else if (lastFive === "3") {
        if (value === "") {
          this.otp2Ref.current?.focus();
        } else {
          this.otp4Ref.current?.focus();
        }
      } else if (lastFive === "4") {
        if (value === "") {
          this.otp3Ref.current?.focus();
        } else {
          this.otp5Ref.current?.focus();
        }
      } else if (lastFive === "5") {
        if (value === "") {
          this.otp4Ref.current?.focus();
        } else {
          this.otp6Ref.current?.focus();
        }
      } else if (lastFive === "6") {
        if (value === "") {
          this.otp5Ref.current?.focus();
        } else {
          this.otp6Ref.current?.focus();
        }
      }
    } else if (name === "allowPromotion" || name === "terms") {
      var checked = e.target.checked;
      this.setState({ [name]: checked, [`${name}Error`]: "" });
    } else if (name === "mobile") {
      const value_ = value.replace(/[^0-9]/g, "");
      this.setState({ [name]: value_, [`${name}Error`]: "" }, () => {
        if (value_.length === 8) {
          this.getCustomerByPhone();
        }
      });
    } else {
      this.setState({ [name]: value, [`${name}Error`]: "" });
    }
  }
  handleChangeSelect(name, value) {
    console.log(value, "valuevaluevaluevalue");
    this.setState({ [name]: value });
  }
  handleChangeDate(datevalue) {
    this.setState({ birthdate: datevalue });
  }
  onPasteCaptureHandler(e) {
    var clipboardData, pastedData;

    // Stop data actually being pasted into div
    e.stopPropagation();
    e.preventDefault();

    // Get pasted data via clipboard API
    clipboardData = e.clipboardData || window.clipboardData;
    pastedData = clipboardData.getData("Text");

    // Do whatever with pasteddata
    if (pastedData !== "") {
      var split = pastedData.split("");
      this.setState({ otp1: split[0] });
      this.setState({ otp2: split[1] });
      this.setState({ otp3: split[2] });
      this.setState({ otp4: split[3] });
      this.setState({ otp5: split[4] });
      this.setState({ otp6: split[5] });
    }
  }

  loginCustomer() {
    let error = 0;
    
    if(appName==='sushitei') {
      if (this.state.mobile === "") {
        this.setState({ mobileError: "This field is required" });
        error++;
      }else {
        this.setState({ mobileError: "" });
      }
    }else {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (this.state.email === "") {
        this.setState({ emailError: "This field is required" });
        error++;
      } else {
        if (!regex.test(this.state.email)) {
          this.setState({ emailError: "Invalid Email" });
          error++;
        } else {
          this.setState({ emailError: "" });
        }
      }
    }
    
    if(this.state.loginpassword==="") {
      this.setState({loginpasswordError:"This field is required"})
      error++;
    }else {
      this.setState({loginpasswordError:""})
    }

    if(error===0) {
      showLoader("login");
      const postObject = {
        uniqueID,
        userName:(appName==='sushitei')?this.state.mobile : this.state.email,
        userType:(appName==='sushitei')?'mobile':'email',
        password:this.state.loginpassword,
        loginType:"password"
      };
      Axios.post(apiUrl + "customer/login", postObject)
        .then((res) => {
          hideLoader("login");
          if (res.data.status === "ok") {
            /* if (this.state.existCustomer === true) { */
              this.setState({ loginopenPopup: false });
              const result = res.data.result;
              localStorage.setItem("customerID", result.customerID);
              localStorage.setItem("firstName", result.firstName);
              localStorage.setItem("lastName", result.lastName);
              localStorage.setItem("email", result.email);
              localStorage.setItem("mobile", result.mobile);
              localStorage.setItem("token", result.token);
              this.setState({ customerID: result.customerID }, () => {
                this.updateCartCustomer();
              });
              toast.success("Login Success");
            /* }else {
               this.setState({
                popupType: "otpverify",
                existCustomer: res.data.existCustomer,
              });
            } */
           
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((e) => {
          var errorMsg = e?.response?.data?.message || e.message;
          toast.error(errorMsg);
          hideLoader("login");
          console.error("Error fetching data:", e);
        });
    }

  }

  forgotPassword() {
    let error = 0;    
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (this.state.email === "") {
      this.setState({ emailError: "This field is required" });
      error++;
    } else {
      if (!regex.test(this.state.email)) {
        this.setState({ emailError: "Invalid Email" });
        error++;
      } else {
        this.setState({ emailError: "" });
      }
    }

    if(error===0) {
      showLoader("forgotPassword");
      const postObject = {
        uniqueID,
        email: this.state.email
      };
      Axios.post(apiUrl + "customer/forgotpassword", postObject)
        .then((res) => {
          hideLoader("forgotPassword");
          if (res.data.status === "ok") {
            this.setState({otpType:'Fogot Password', popupType:'otpverify'}, ()=> {
               toast.success(res.data.message);
            })
           
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((e) => {
          var errorMsg = e?.response?.data?.message || e.message;
          toast.error(errorMsg);
          hideLoader("forgotPassword");
          console.error("Error fetching data:", e);
        });
    }

  }

  changePassword() {
    let error = 0;    
    if (this.state.loginpassword === "") {
      this.setState({ loginpasswordError: "This field is required" });
      error++;
    } else {
      this.setState({ loginpasswordError: "" });
    }
    if (this.state.loginconfirmpassword === "") {
      this.setState({ loginconfirmpasswordError: "This field is required" });
      error++;
    } else {
      if(this.state.loginpassword!==this.state.loginconfirmpassword) {
        this.setState({ loginpasswordError: "Confirm Password does not match" });
      }else {
        this.setState({ loginpasswordError: "" });
      }      
    }

    if(error===0) {
      showLoader("changePassword");
      const postObject = {
        uniqueID,
        email: this.state.email,
        password:this.state.loginpassword
      };
      Axios.post(apiUrl + "customer/updatepassword", postObject)
        .then((res) => {
          hideLoader("changePassword");
          if (res.data.status === "ok") {
            this.setState({otpType:'Login', popupType:'login', loginpassword:"", loginconfirmpassword:"'"}, ()=> {
               toast.success(res.data.message);
            })
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((e) => {
          var errorMsg = e?.response?.data?.message || e.message;
          toast.error(errorMsg);
          hideLoader("changePassword");
          console.error("Error fetching data:", e);
        });
    }

  }

  
  confirmOTP() {
    this.setState({ emailError: "" });
    showLoader("verifyOTP");
    const otp = `${this.state.otp1}${this.state.otp2}${this.state.otp3}${this.state.otp4}${this.state.otp5}${this.state.otp6}`;
    if (otp !== "") {
      if (otp.length === 6) {
        const postObject = {
          uniqueID,
          email: this.state.email,
          otp: otp,
          existCustomer: this.state.existCustomer,
          otpType:this.state.otpType
        };
        Axios.post(apiUrl + "customer/verifyOTP", postObject)
          .then((res) => {
            hideLoader("verifyOTP");
            if (res.data.status === "ok") {
              if(this.state.otpType==="Login") {
                if (this.state.existCustomer === true) {
                  this.setState({ loginopenPopup: false });
                  const result = res.data.result;
                  localStorage.setItem("customerID", result.customerID);
                  localStorage.setItem("firstName", result.firstName);
                  localStorage.setItem("lastName", result.lastName);
                  localStorage.setItem("email", result.email);
                  localStorage.setItem("mobile", result.mobile);
                  localStorage.setItem("token", result.token);
                  this.setState({ customerID: result.customerID }, () => {
                    this.updateCartCustomer();
                  });
                  toast.success("Login Success");
                } else {
                  this.setState({ popupType: "register" });
                }
              } else if(this.state.otpType==="Fogot Password") {
                this.setState({ popupType: "restpassword" });
              }
              
            } else {
              toast.error(res.data.message);
            }
          })
          .catch((e) => {
            console.log(e);
            var errorMsg = e?.response?.data?.message || e.message;
            toast.error(errorMsg);
            hideLoader("verifyOTP");
            console.error("Error fetching data:", e);
          });
      } else {
        this.setState({ otpError: "OPT must be 6 characters" });
      }
    } else {
      this.setState({ otpError: "OTP is required" });
    }
  }

  confirmRegistration() {
    let error = 0;
    if (this.state.firstName === "") {
      this.setState({ firstNameError: "This field is required" });
      error++;
    } else {
      this.setState({ firstNameError: "" });
    }

    if (this.state.mobile === "") {
      this.setState({ mobileError: "This field is required" });
      error++;
    } else {
      if (this.state.mobile.length === 8) {
        this.setState({ mobileError: "" });
      } else {
        this.setState({ mobileError: "Mobile Number not a valid" });
        error++;
      }
    }

    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (this.state.email === "") {
      this.setState({ emailError: "This field is required" });
      error++;
    } else {
      if (!regex.test(this.state.email)) {
        this.setState({ emailError: "Invalid Email" });
        error++;
      } else {
        this.setState({ emailError: "" });
      }
    }

    if(appName==='sushitei') {
      if (this.state.loginpassword === "") {
        this.setState({ loginpasswordError: "This field is required" });
        error++;
      } else {
        this.setState({ loginpasswordError: "" });
      }
      if (this.state.loginconfirmpassword === "") {
        this.setState({ loginconfirmpasswordError: "This field is required" });
        error++;
      } else {
        if(this.state.loginpassword!==this.state.loginconfirmpassword) {
          this.setState({ loginpasswordError: "Confirm Password does not match" });
        }else {
          this.setState({ loginpasswordError: "" });
        }
      }
    }

    if (this.state.terms === false) {
      this.setState({ termsError: "This field is required" });
      error++;
    } else {
      this.setState({ termsError: "" });
    }
    if (this.state.allowPromotion === false) {
      this.setState({ allowPromotionError: "This field is required" });
      error++;
    } else {
      this.setState({ allowPromotionError: "" });
    }
    alert(error)
    if (error === 0) {
      showLoader("registion");
      const otp = `${this.state.otp1}${this.state.otp2}${this.state.otp3}${this.state.otp4}${this.state.otp5}${this.state.otp6}`;
      if (otp !== "" || appName==='sushitei') {
        if (otp.length === 6 || appName==='sushitei') {
          let postObject = {
            uniqueID,
            email: this.state.email,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            mobile: this.state.mobile,
            terms: this.state.terms,
            allowPromotion: this.state.allowPromotion,
          };
          if(appName==='sushitei') {
            postObject.password = this.state.loginpassword;
          }
          Axios.post(apiUrl + "customer/registration", postObject)
            .then((res) => {
              hideLoader("registion");
              if (res.data.status === "ok") {
                this.setState({ loginopenPopup: false });
                const result = res.data.result;
                localStorage.setItem("customerID", result.customerID);
                localStorage.setItem("firstName", result.firstName);
                localStorage.setItem("lastName", result.lastName);
                localStorage.setItem("email", result.email);
                localStorage.setItem("mobile", result.mobile);
                localStorage.setItem("token", result.token);
                toast.success("Register Success");
                this.setState({ customerID: result.customerID }, () => {
                  this.updateCartCustomer();
                });
              } else {
                toast.error(
                  <div dangerouslySetInnerHTML={{ __html: res.data.message }} />
                );
              }
            })
            .catch((e) => {
              console.log(e);
              var errorMsg = e?.response?.data?.message || e.message;
              toast.error(errorMsg);
              hideLoader("registion");
              console.error("Error fetching data:", e);
            });
        } else {
          this.setState({ otpError: "OPT must be 6 characters" });
        }
      } else {
        this.setState({ otpError: "OTP is required" });
      }
    }
  }
  getCustomerByPhone() {
    const postObject = {
      uniqueID,
      mobile: this.state.mobile,
    };
    Axios.post(apiUrl + "customer/getCustomerByPhone", postObject)
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          const firstName = result?.firstName ?? "";
          this.setState({
            email: result?.email ?? "",
            firstName: result?.firstName ?? "",
            terms: false,
            firstNameError:
              firstName !== "" && firstName !== null
                ? ""
                : "This field is required",
          });
        }
      })
      .catch((e) => {
        console.error("Error fetching data:", e);
      });
  }

  confirmGustLogin() {
    let error = 0;
    if (this.state.firstName === "") {
      this.setState({ firstNameError: "This field is required" });
      error++;
    } else {
      this.setState({ firstNameError: "" });
    }

    if (this.state.mobile === "") {
      this.setState({ mobileError: "This field is required" });
      error++;
    } else {
      if (this.state.mobile.length === 8) {
        this.setState({ mobileError: "" });
      } else {
        this.setState({ mobileError: "Mobile Number not a valid" });
        error++;
      }
    }
    if(this.state.popupType !== "guestlogin") {
      if (this.state.terms === false) {
        this.setState({ termsError: "This field is required" });
        error++;
      } else {
        this.setState({ termsError: "" });
      }
    }

    if (error === 0) {
      showLoader("guestlogin");
      const postObject = {
        uniqueID,
        email: this.state.email,
        firstName: this.state.firstName,
        mobile: this.state.mobile,
        terms: false,
        allowPromotion: false,
        customerSource: "Ecommerce",
      };
      Axios.post(apiUrl + "customer/guestLogin", postObject)
        .then((res) => {
          hideLoader("guestlogin");
          if (res.data.status === "ok") {
            this.setState({ loginopenPopup: false });
            const result = res.data.result;
            localStorage.setItem("customerID", result.customerID);
            localStorage.setItem("firstName", result.firstName);
            localStorage.setItem("lastName", result.lastName);
            localStorage.setItem("email", result.email);
            localStorage.setItem("mobile", result.mobile);
            localStorage.setItem("token", result.token);
            toast.success("Login Success");
            this.setState({ customerID: result.customerID }, () => {
              this.updateCartCustomer();
            });
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((e) => {
          console.log(e);
          var errorMsg = e?.response?.data?.message || e.message;
          toast.error(errorMsg);
          hideLoader("guestlogin");
          console.error("Error fetching data:", e);
        });
    }
  }
  updateCartCustomer() {
    const referenceID = getReferenceID();
    const postObject = {
      uniqueID,
      customerID: this.state.customerID,
      referenceID: referenceID,
    };
    Axios.post(apiUrl + "cart/updateCustomer", postObject)
      .then((res) => {
        this.setState({ trigerCart: true });

        const redirect = cookie.load("redirect") ?? "";
        if (redirect !== "") {
          cookie.remove("redirect", { path: "/" });
          this.props.history.push(`/${redirect}`);
        }
      })
      .catch((e) => {
        this.setState({ trigerCart: true });
        setTimeout(() => {
          const redirect = cookie.load("redirect") ?? "";
          if (redirect !== "") {
            cookie.remove("redirect", { path: "/" });
            this.props.history.push(`/${redirect}`);
          } else {
            this.props.history.push("/myprofile");
          }
        }, 300);

        console.error("Error fetching data:", e);
      });
  }

  maskEmail(email) {
    if (email !== "") {
      const [username, domain] = email.split("@"); // Split email into username & domain
      if (username.length <= 3) {
        return `${username[0]}***@${domain}`; // If username is short, show only first letter
      }
      return `${username.substring(0, 3)}******@${domain}`; // Mask after first 3 chars
    }
  }

  openAvail(e) {
    e.preventDefault();
    this.setState({ openAvailPopup: true });
  }

  getMemberOtp(e) {
    e.preventDefault();
    let error = 0;
    if (this.state.mobile === "") {
      this.setState({ mobileError: "This field is required" });
    } else {
      if (this.state.mobile.length === 8) {
        this.setState({ mobileError: "" });
      } else {
        this.setState({ mobileError: "Mobile Number not a valid" });
        error++;
      }
    }
    if (error === 0) {
      showLoader("member-otp");
      const postObject = {
        phone: this.state.mobile,
        uniqueID,
      };
      Axios.post(apiUrl + "customer/memberSendOTP", postObject)
        .then((res) => {
          hideLoader("member-otp");
          if (res.data.status === "ok") {
            this.setState(
              {
                allowEnterOTP: true,
                showGetOTP: false,
                showResendOTP: false,
                countTime: 120,
                showCount: true,
              },
              () => {
                this.startCount();
              }
            );
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((e) => {
          var errorMsg = e?.response?.data?.message || e.message;
          toast.error(errorMsg);
          hideLoader("member-otp");
          console.error("Error fetching data:", e);
        });
    }
  }
  startCount() {
    setTimeout(() => {
      let countTime = this.state.countTime;
      countTime = countTime - 1;
      if (countTime > 0) {
        this.setState({ countTime }, () => {
          this.startCount();
        });
      } else {
        this.setState({
          showResendOTP: true,
          showCount: false,
          allowEnterOTP: false,
        });
      }
    }, 1000);
  }
  verifyMemberOtp() {
    let error = 0;
    if (this.state.otp === "") {
      this.setState({ otpError: "This field is required" });
      error++;
    } else if (this.state.otp.length !== 5) {
      this.setState({ otpError: "Invalid OTP" });
      error++;
    } else {
      this.setState({ otpError: "" });
    }
    if (error === 0) {
      showLoader("member-otp-verify");
      const postObject = {
        phone: this.state.mobile,
        otp: this.state.otp,
        uniqueID,
      };
      Axios.post(apiUrl + "customer/memberValidateOTP", postObject)
        .then((res) => {
          hideLoader("member-otp-verify");
          if (res.data.status === "ok") {
            this.setState({
              allowEnterOTP: false,
              showGetOTP: false,
              showResendOTP: false,
              countTime: 0,
              showCount: false,
              verifiedOTP: true,
            });
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((e) => {
          var errorMsg = e?.response?.data?.message || e.message;
          toast.error(errorMsg);
          hideLoader("member-otp-verify");
          console.error("Error fetching data:", e);
        });
    }
  }
  confirmMemberLogin() {
    let error = 0;
    if (this.state.mobile === "") {
      this.setState({ mobileError: "This field is required" });
    } else {
      if (this.state.mobile.length === 8) {
        this.setState({ mobileError: "" });
      } else {
        this.setState({ mobileError: "Mobile Number not a valid" });
        error++;
      }
    }
    if (this.state.password === "") {
      this.setState({ passwordError: "This field is required" });
      error++;
    } else {
      this.setState({ passwordError: "" });
    }
    if (error === 0) {
      showLoader("MemberLogin");
      let postObject = {
        phone: this.state.mobile,
        password: this.state.password,
        uniqueID,
        customerID:this.state.customerID
      };
      Axios.post(apiUrl + "customer/memberLogin", postObject, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((res) => {
          hideLoader("MemberLogin");
          console.log(res.data, "res.data");
          if (res.data.status === "ok") {
            const result = res.data.result;
            localStorage.setItem("customerID", result.customerID);
            localStorage.setItem("firstName", result.firstName);
            localStorage.setItem("lastName", result.lastName);
            localStorage.setItem("email", result.email);
            localStorage.setItem("mobile", result.mobile);
            localStorage.setItem("token", result.token);
            this.setState(
              { customerID: result.customerID, loginopenPopup: false },
              () => {
                this.updateCartCustomer();
              }
            );
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((e) => {
          var errorMsg = e?.response?.data?.message || e.message;
          toast.error(errorMsg);
          hideLoader("MemberLogin");
          console.error("Error fetching data:", e);
        });
    }
  }

  confirmMemberRegister() {
    let error = 0;
    if (this.state.mobile === "") {
      this.setState({ mobileError: "This field is required" });
    } else {
      if (this.state.mobile.length === 8) {
        this.setState({ mobileError: "" });
      } else {
        this.setState({ mobileError: "Mobile Number not a valid" });
        error++;
      }
    }
    if (this.state.firstName === "") {
      this.setState({ firstNameError: "This field is required" });
      error++;
    } else {
      this.setState({ firstNameError: "" });
    }
    if (this.state.email === "") {
      this.setState({ emailError: "This field is required" });
      error++;
    } else {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!regex.test(this.state.email)) {
        this.setState({ emailError: "Invalid Email" });
      } else {
        this.setState({ emailError: "" });
      }
    }
    if (this.state.password === "") {
      this.setState({ passwordError: "This field is required" });
      error++;
    } else {
      this.setState({ passwordError: "" });
    }
    if (this.state.cpassword === "") {
      this.setState({ cpasswordError: "This field is required" });
      error++;
    } else {
      if (this.state.password !== this.state.cpassword) {
        this.setState({
          cpasswordError: "Confirmation password does not match",
        });
        error++;
      } else {
        this.setState({ cpasswordError: "" });
      }
    }
    if (this.state.gender === "") {
      this.setState({ genderError: "This field is required" });
      error++;
    } else {
      this.setState({ genderError: "" });
    }

    if (this.state.nationality === "") {
      this.setState({ nationalityError: "This field is required" });
      error++;
    } else {
      this.setState({ nationalityError: "" });
    }
    if (this.state.terms === false) {
      this.setState({ termsError: "This field is required" });
      error++;
    } else {
      this.setState({ termsError: "" });
    }
    if (error === 0) {
      this.setState({ openomisePopup: true, loginopenPopup: false });
    }
  }

  processOmiseToken(token) {
    if (token !== "") {
      let postObject = {
        name: this.state.firstName,
        email: this.state.email,
        phone: this.state.mobile,
        password: this.state.password,
        referrerCode: this.state.referrerCode,
        registerType: "Web",
        birthDate: this.state.birthdate,
        terms: this.state.terms,
        allowPromotion: this.state.allowPromotion,
        uniqueID,
        token,
        grandTotal: this.state.membershipAmount,
        callbackurl: mainUrl,
        checkoutType: "MemberRegistration",
      };
      Axios.post(apiUrl + "payment/processRegisterOmisePayment", postObject, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((res) => {
          hideLoader("prcessOmise");
          console.log(res.data, "res.data");
          if (res.data.status === "ok") {
            localStorage.setItem(
              "paymentRequestIdOmise",
              res.data.payment_requestId
            );
            window.location.href = res.data.redirectURL;
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((e) => {
          var errorMsg = e?.response?.data?.message || e.message;
          toast.error(errorMsg);
          hideLoader("member_prcessOmise");
          console.error("Error fetching data:", e);
        });
    }
  }

  render() {
    return (
      <React.Fragment>
        <header>
          <div className="header-block">
            <div className="container">
              <div className="header-inner">
                <div className="res-nav-profile">
                  <div className="nav-icon">
                    <a
                      href="/"
                      onClick={(e) => {
                        e.preventDefault();
                        document.body.classList.add("nav-active");
                      }}
                    >
                      <img src={navb} alt="Nav" />
                    </a>
                  </div>
                  <div className="nav-profile">
                    <a href="/" onClick={this.openLogin.bind(this)}>
                      <img src={profile} alt="profile" />
                    </a>
                  </div>
                </div>
                <div className="header-logo">
                  <Link to={"/"}>
                    <img src={siteLogo} alt={companyName} />
                  </Link>
                </div>
                <div className="header-rhs">
                  <div className="header-inputs">
                    {this.state.seletedAvilablityId === deliveryId && (
                      <div className="input-dl">
                        <div className="rel in-parent">
                          <div className="sdl-input">
                            {localStorage.getItem("deliveryPostalCode") ??
                              "Select delivery Location"}
                          </div>
                          <img className="sdl-map" src={mapicon} alt="map" />
                        </div>
                      </div>
                    )}
                    {this.state.seletedAvilablityId !== "" && (
                      <div
                        className={`input-dl ${
                          parseInt(this.state.slotType) === 2 ? "slotType" : ""
                        }`}
                      >
                        <div className="rel in-parent">
                          <div className="sdl-input">
                            {cookie.load("outletName") ?? ""}{" "}
                            {this.state.displyDate !== "" ? (
                              <React.Fragment>
                                <b>{this.state.displyDate}</b> at{" "}
                                <b>
                                  {parseInt(this.state.slotType) === 1 ? (
                                    this.state.displyTime
                                  ) : (
                                    <>
                                      {this.state.orderSlotStrTime} -{" "}
                                      {this.state.orderSlotEndTime}
                                    </>
                                  )}
                                </b>
                              </React.Fragment>
                            ) : (
                              "Select Date & Time"
                            )}
                          </div>
                          <TimeIcon className="sdl-time" alt="time" />
                          {/* <img className="sdl-time" src={time} alt="time" /> */}
                        </div>
                      </div>
                    )}
                    <div className="pick-item">
                      <a
                        href="/"
                        className="pick-item-link"
                        onClick={this.openAvail.bind(this)}
                      >
                        <span>
                          {(() => {
                            if (this.state.seletedAvilablityName==="") {
                              return (
                               <img src={ShopImg} alt="cycle" />
                              )
                            } else if (this.state.seletedAvilablityName==="Pickup") {
                              return (
                                <img src={takeawayImg} alt="cycle" />
                              )
                            } else  if (this.state.seletedAvilablityName==="Delivery") {
                              return (
                                <img src={cycle} alt="cycle" />
                              )
                            }
                          })()}
                          {" "}
                          {this.state.seletedAvilablityName !== ""
                            ? (this.state.seletedAvilablityName==='Pickup'?'Takeaway':this.state.seletedAvilablityName)
                            : "Order Now"}
                        </span>
                      </a>
                    </div>
                    {this.state.customerID === "" && this.state.enableAscentisCRM && (
                        <div className="header-login">
                          <div className="pick-item">
                            <a
                              href="/"
                              className="pick-item-link"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({ ascentisloginopenPopup: true });
                              }}
                            >
                              <span>Login</span>
                            </a>
                          </div>
                          <div className="pick-item">
                            <a
                              href="/"
                              className="pick-item-link"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  ascentissignupopenPopup: true,
                                });
                              }}
                            >
                              <span>Sign Up</span>
                            </a>
                          </div>
                        </div>
                      )}
                  </div>
                  <div className="header-info">
                    <div className="view-menu">
                      <Link to={`/${menuPage}`}>
                        <img src={menuicon} alt="View Menu" />
                      </Link>
                    </div>
                    {this.state.enableAscentisCRM ? (
                      this.state.customerID !== "" && (
                        <div className="header-profile">
                          <a href="/" onClick={this.openLogin.bind(this)}>
                            <img src={profile} alt="profile" />
                          </a>
                        </div>
                      )
                    ) : (
                      <div className="header-profile">
                        <a href="/" onClick={this.openLogin.bind(this)}>
                          <img src={profile} alt="profile" />
                        </a>
                      </div>
                    )}
                    {/* <div className="header-wishlist">
                      <a href="/">
                        <img src={wishlist} alt="wishlist" />
                      </a>
                    </div> */}
                    <div className="header-cart">
                      <a
                        href="/"
                        className="header-cart-link"
                        onClick={this.openCart.bind(this)}
                      >
                        <img src={cartbag} className="cart-img" alt="cartbag" />
                        <span className="item-count">
                          {this.state.totalItem}
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mobile-pick-item">
            <div className="mp-lhs">
              <div className="mp-lhs-iner">
                {this.state.displyDate !== "" ? (
                  <React.Fragment>
                    <b>{this.state.displyDate}</b>
                    <span>at</span>{" "}
                    <b>
                      {parseInt(this.state.slotType) === 1 ? (
                        this.state.displyTime
                      ) : (
                        <>
                          {this.state.orderSlotStrTime} -{" "}
                          {this.state.orderSlotEndTime}
                        </>
                      )}
                    </b>
                  </React.Fragment>
                ) : (
                  "Select Date & Time"
                )}
              </div>
              <TimeIcon className="sdl-time" alt="time" />
            </div>
            <div className="mp-rhs">
              <a
                href="/"
                className="pick-item-link"
                onClick={this.openAvail.bind(this)}
              >
                <span>
                  <img src={cycle} alt="cycle" />{" "}
                  {this.state.seletedAvilablityName !== ""? (this.state.seletedAvilablityName==='Pickup'?'Takeaway':this.state.seletedAvilablityName): "Order Now"}
                </span>
              </a>
            </div>
          </div>
          <Cart
            trigerCart={this.state.trigerCart}
            openCart={this.state.openCart}
            reloadCartPage={this.state.reloadCartPage}
            updateStateValue={this.updateStateValue.bind(this)}
          />
        </header>
        <div className="nav-sidebar">
          <a
            href="/"
            className="menu-close"
            onClick={(e) => {
              e.preventDefault();
              document.body.classList.remove("nav-active");
            }}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </a>
          <div className="nav__content">
            <ul>
              <li className="nav__list-item">
                <Link to={"/"}>Home</Link>
              </li>
              <li className="nav__list-item">
                <Link to={"/about-us"}>About Us</Link>
              </li>
              <li className="nav__list-item">
                <Link to={"/outlets"}>Our Outlets</Link>
              </li>
              <li className="nav__list-item">
                <Link to={"/contactus"}>Contact Us</Link>
              </li>
            </ul>
          </div>
        </div>
        <Popup
          open={this.state.ascentisloginopenPopup}
          onClose={() => this.setState({ ascentisloginopenPopup: false })}
          modal
          closeOnDocumentClick={false}
          className="detail-popup asseting-main-login"
        >
          <div className="popup-cover">
            <div className="pm-close">
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({ ascentisloginopenPopup: false });
                }}
              >
                <img className="close-top" src={closei} alt="close" />
              </a>
            </div>
            <div class="ascentis-member">
              <h1 class="title">LOGIN ACCOUNT</h1>

              <div class="login-container">
                <div>
                  <div class="member-cards member">
                    <img src={susteirewards} alt="reward" />
                    <h2 class="logo">{companyName.toUpperCase()} REWARDS</h2>
                    <ul class="features memberfeatures">
                      <li>
                        <i class="fa fa-check"></i> Rebates
                      </li>
                      <li>
                        <i class="fa fa-check"></i> Birthday bonus
                      </li>
                      <li>
                        <i class="fa fa-check"></i> Exclusive Privileges
                      </li>
                    </ul>
                    <button
                      class="btn member-btn"
                      onClick={() => {
                        if(appName==='sushitei') {
                          this.setState({
                            ascentisloginopenPopup: false,
                            loginopenPopup: true,
                            popupType: "ascentislogin",
                          });
                        }else {
                          
                        }
                      }}
                    >
                      MEMBER LOGIN
                    </button>
                  </div>
                  <p class="join-text"><a href="https://sushitei.com/membership-and-rewards/">Join Now for Exclusive Benefits!</a></p>
                </div>

                <div class="divider">OR</div>

                <div class="member-cards quick">
                  <h2>QUICK CHECK OUT ACCOUNT</h2>
                  <p class="subtitle">
                    (Complimentary account for online ordering use only)
                  </p>
                  <ul class="features">
                    <li>
                      <i class="fa fa-times"></i> Rebates
                    </li>
                    <li>
                      <i class="fa fa-times"></i> Birthday bonus
                    </li>
                    <li>
                      <i class="fa fa-times"></i> Exclusive Privileges
                    </li>
                  </ul>
                  <button
                    class="btn quick-btn"
                    onClick={() => {
                      this.setState({
                        ascentisloginopenPopup: false,
                        loginopenPopup: true,
                        popupType: (appName==='sushitei')?"login":"guestlogin",
                      });
                    }}
                  >
                    LOGIN
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Popup>
        <Popup
          open={this.state.ascentissignupopenPopup}
          onClose={() => this.setState({ ascentissignupopenPopup: false })}
          modal
          closeOnDocumentClick={false}
          className="detail-popup asseting-main-register"
        >
          <div className="popup-cover">
            <div className="pm-close">
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({ ascentissignupopenPopup: false });
                }}
              >
                <img className="close-top" src={closei} alt="close" />
              </a>
            </div>
            <div class="ascentis-member">
              <h1 class="title">CREATE AN ACCOUNT</h1>

              <div class="login-container">
                <div>
                  <div class="member-cards member">
                    <img src={susteirewards} alt="rewards" />
                    <p>
                      SIGN UP {companyName} Reward membership for{" "}
                      <span>S${this.state.membershipAmount}</span> to enjoy
                      exclusive privileges and benefits.{" "}
                      <a href="https://sushitei.com/membership-and-rewards/">Find out more.</a>
                    </p>
                    <ul class="features memberfeatures">
                      <li>
                        <i class="fa fa-check"></i> Rebates
                      </li>
                      <li>
                        <i class="fa fa-check"></i> Birthday bonus
                      </li>
                      <li>
                        <i class="fa fa-check"></i> Exclusive Privileges
                      </li>
                    </ul>
                    <button
                      class="btn member-btn member-login-btn"
                      onClick={() => {
                        if(appName==='sushitei') {
                          this.setState({
                            ascentissignupopenPopup: false,
                            loginopenPopup: true,
                            popupType: "ascentisregister",
                          });
                        }
                      }}
                    >
                      REGISTER MEMBERSHIP
                      <br />
                      <span>(Paid MemberShip)</span>
                    </button>
                  </div>
                  <p class="join-text">Join Now for Exclusive Benefits!</p>
                </div>

                <div class="divider">OR</div>

                <div class="member-cards quick">
                  <h2>QUICK CHECK OUT ACCOUNT</h2>
                  <p class="subtitle">
                    (Complimentary account for online ordering use only)
                  </p>
                  <ul class="features">
                    <li>
                      <i class="fa fa-times"></i> Rebates
                    </li>
                    <li>
                      <i class="fa fa-times"></i> Birthday bonus
                    </li>
                    <li>
                      <i class="fa fa-times"></i> Exclusive Privileges
                    </li>
                  </ul>
                  <button
                    class="btn quick-btn member-login-btn"
                    onClick={() => {
                      this.setState({
                        ascentissignupopenPopup: false,
                        loginopenPopup: true,
                        popupType:  (appName==='sushitei')?"register":"guestregister",
                      });
                    }}
                  >
                    Register Now
                    <br />
                    <span>(Free Account)</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Popup>
        <Popup
          open={this.state.loginopenPopup}
          onClose={() => this.setState({ loginopenPopup: false })}
          modal
          closeOnDocumentClick={false}
          className={`popup-master-small login-${this.state.popupType}`}
        >
          <div className="popup-cover">
            {/* Login Popup */}
            {this.state.popupType === "login" && (
              <div className="login-region">
                <div className="pm-close">
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ loginopenPopup: false });
                    }}
                  >
                    <img className="close-top" src={closei} alt="close" />
                  </a>
                </div>
                <div className="pm-header">
                  <h4>Your account</h4>
                  <span>Log in or sign up to get started. </span>
                </div>
                {appName==='sushitei' ? (
                  <div className="form-group">
                    <label className="control-label">Mobile Number*</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter Mobile Number*"
                      value={this.state.mobile}
                      maxLength={8}
                      onChange={this.handleChange.bind(this, "mobile")}
                    />
                    {this.state.mobileError !== "" && (
                      <span className="error">{this.state.mobileError}</span>
                    )}
                  </div>
                ):(
                  <div className="form-group">
                    <label className="control-label">Email</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter your mail*"
                      value={this.state.email}
                      onChange={this.handleChange.bind(this, "email")}
                    />
                    {this.state.emailError !== "" && (
                      <span className="error">{this.state.emailError}</span>
                    )}
                  </div>
                )}
                <div className="form-group">
                  <label className="control-label">Password</label>
                  <input
                    className="form-control"
                    type="password"
                    placeholder="Enter your password*"
                    value={this.state.loginpassword}
                    onChange={this.handleChange.bind(this, "loginpassword")}
                  />
                  {this.state.loginpasswordError !== "" && (
                    <span className="error">{this.state.loginpasswordError}</span>
                  )}
                </div>
                {appName==='sushitei' ? (
                  <div className="guestlogin">
                    <a
                      href="/"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ popupType: "forgotpassword" });
                      }}
                    >
                      Forgot Password?
                    </a>
                  </div>
                ):(
                  <div className="guestlogin">
                    <a
                      href="/"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ popupType: "guestlogin" });
                      }}
                    >
                      Login With Guest
                    </a>
                  </div>
                )}
                <div className="pm-single-button">
                  <button
                    className="button"
                    id="guestlogin"
                    onClick={this.loginCustomer.bind(this)}
                  >
                    Log in
                  </button>
                </div>
              </div>
            )}
            

            {/* Forgot Popup */}
            {this.state.popupType === "forgotpassword" && (
              <div className="login-region">
                <div className="pm-close">
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ loginopenPopup: false });
                    }}
                  >
                    <img className="close-top" src={closei} alt="close" />
                  </a>
                </div>
                <div className="pm-header">
                  <h4>Forgot Password</h4>
                </div>
                <div className="form-group">
                  <label className="control-label">Email</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter your mail*"
                    value={this.state.email}
                    onChange={this.handleChange.bind(this, "email")}
                  />
                  {this.state.emailError !== "" && (
                    <span className="error">{this.state.emailError}</span>
                  )}
                </div>
                <div className="guestlogin">
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ popupType: "login" });
                    }}
                  >
                    Back to Login
                  </a>
                </div>
                <div className="pm-single-button">
                  <button
                    className="button"
                    id="forgotPassword"
                    onClick={this.forgotPassword.bind(this)}
                  >
                    Send OTP
                  </button>
                </div>
              </div>
            )}


             {this.state.popupType === "restpassword" && (
              <div className="login-region">
                <div className="pm-close">
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ loginopenPopup: false });
                    }}
                  >
                    <img className="close-top" src={closei} alt="close" />
                  </a>
                </div>
                <div className="pm-header">
                  <h4>Rest Password</h4>
                </div>
                <div className="form-group">
                  <label className="control-label">New Password</label>
                  <input
                    className="form-control"
                    type="password"
                    placeholder="Enter your new password*"
                    value={this.state.loginpassword}
                    onChange={this.handleChange.bind(this, "loginpassword")}
                  />
                  {this.state.loginpasswordError !== "" && (
                    <span className="error">{this.state.loginpasswordError}</span>
                  )}
                </div>
                <div className="form-group">
                  <label className="control-label">Confirm Password</label>
                  <input
                    className="form-control"
                    type="password"
                    placeholder="Enter your confirm password*"
                    value={this.state.loginconfirmpassword}
                    onChange={this.handleChange.bind(this, "loginconfirmpassword")}
                  />
                  {this.state.loginconfirmpasswordError !== "" && (
                    <span className="error">{this.state.loginconfirmpasswordError}</span>
                  )}
                </div>
                {appName==='sushitei' ? (
                  <div className="guestlogin">
                    <a
                      href="/"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ popupType: "forgotpassword" });
                      }}
                    >
                      Forgot Password?
                    </a>
                  </div>
                ):(
                  <div className="guestlogin">
                    <a
                      href="/"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ popupType: "guestlogin" });
                      }}
                    >
                      Login With Guest
                    </a>
                  </div>
                )}
                <div className="pm-single-button">
                  <button
                    className="button"
                    id="changePassword"
                    onClick={this.changePassword.bind(this)}
                  >
                    Change Password
                  </button>
                </div>
              </div>
            )}

            {(this.state.popupType === "guestlogin" || this.state.popupType === "guestregister") && (
              <div className="create-account-region">
                <div className="pm-close">
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ loginopenPopup: false });
                    }}
                  >
                    <img className="close-top" src={closei} alt="close" />
                  </a>
                </div>
                <div className="pm-header">
                  <h4>QUICK CHECK OUT {this.state.popupType === "guestregister"?'ACCOUNT REGISTRATION':''}</h4>
                </div>
                <div className="create-account-form">
                  <div className="form-group">
                    <label className="control-label">Mobile Number*</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter Mobile Number"
                      value={this.state.mobile}
                      maxLength={8}
                      onChange={this.handleChange.bind(this, "mobile")}
                    />
                    {this.state.mobileError !== "" && (
                      <span className="error">{this.state.mobileError}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="control-label">First Name*</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter First Name"
                      value={this.state.firstName}
                      onChange={this.handleChange.bind(this, "firstName")}
                    />
                    {this.state.firstNameError !== "" && (
                      <span className="error">{this.state.firstNameError}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="control-label">Enter your mail*</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter your mail*"
                      value={this.state.email}
                      onChange={this.handleChange.bind(this, "email")}
                    />
                    {this.state.mobileError !== "" && (
                      <span className="error">{this.state.emailError}</span>
                    )}
                  </div>
                  {this.state.popupType === "guestregister" &&
                  <>
                    <div className="form-group-checkbox">
                      <input
                        type="checkbox"
                        checked={this.state.terms}
                        onChange={this.handleChange.bind(this, "terms")}
                      />
                      <span>
                        By creating an account, I agree with the,{" "}
                        <a href="/privacy-policy" target="_blank">
                          Terms & Conditions
                        </a>{" "}
                        and the{" "}
                        <a href="/terms-and-conditions" target="_blank">
                          Privacy Policy
                        </a>
                      </span>
                    </div>
                    <div className="form-group-checkbox">
                    <input
                      type="checkbox"
                      checked={this.state.allowPromotion}
                      onChange={this.handleChange.bind(this, "allowPromotion")}
                    />
                    <span>
                      
                      By submitting this form, I hereby give my consent to{" "}
                      {companyName} to collect, use and disclose my personal
                      data for the purposes of processing my membership
                      application, administering my membership, as well as
                      notifying and contacting me regarding membership, sending
                      me marketing, advertising and promotional information
                      about products/services that {companyName} and its
                      affiliates may be offering, via calls, text messages, post
                      and emails. I am aware that I may update the personal data
                      and/or withdraw the consent provided by me at any time by
                      contacting {termsEmail}. The {companyName} Privacy Policy
                      and how my personal data will be used is also available{" "}
                      <a href={termsEmailLink} target="_blank" rel="noreferrer">here</a>
                    </span>
                  </div>
                  </>
                  }
                  {this.state.termsError !== "" && (
                    <div>
                      <span className="error">{this.state.termsError}</span>
                    </div>
                  )}
                </div>
                <div className="spacer"> </div>
                <div className="pm-single-button">
                  <button
                    className="button"
                    id="registion"
                    onClick={this.confirmGustLogin.bind(this)}
                  >
                    Continue
                  </button>
                </div>
              </div>
            )}
            {this.state.popupType === "ascentislogin" && (
              <div className="create-account-region">
                <div className="pm-close">
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ loginopenPopup: false });
                    }}
                  >
                    <img className="close-top" src={closei} alt="close" />
                  </a>
                </div>
                <div className="sustei-reward-patenr">
                  <div className="sustei-reward">
                    <div className="msc-header">
                      <img src={susteirewards} alt="Logo" />
                      <span>REWARDS MEMBERSHIP PROGRAM</span>
                    </div>
                  </div>
                </div>
                <div className="pm-header">
                  <h4>Login Form</h4>
                </div>
                <div className="create-account-form">
                  <div className="form-group">
                    <div className="seperate-mob-main">
                      <div className="seperate-mob">
                        <Select
                          placeholder="Code"
                          onChange={this.handleChangeSelect.bind(
                            this,
                            "mobilecountry"
                          )}
                          defaultValue={[
                            {
                              label: "SG | +65",
                              value: "+65",
                            },
                          ]}
                          menuIsOpen={false}
                          isDisabled={true}
                          options={[
                            {
                              label: "SG | +65",
                              value: "65",
                            },
                          ]}
                        />
                        <div className="reg-mobile">
                          <label className="control-label">
                            Mobile Number*
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Enter Mobile Number"
                            value={this.state.mobile}
                            maxLength={8}
                            onChange={this.handleChange.bind(this, "mobile")}
                          />
                          {this.state.verifiedOTP && (
                            <i class="fa fa-check-circle"></i>
                          )}
                          {this.state.mobileError !== "" && (
                            <span className="error">
                              {this.state.mobileError}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="control-label">Password*</label>
                    <input
                      className="form-control"
                      type="password"
                      placeholder="Enter your Password*"
                      value={this.state.password}
                      onChange={this.handleChange.bind(this, "password")}
                    />
                    {this.state.passwordError !== "" && (
                      <span className="error">{this.state.passwordError}</span>
                    )}
                  </div>
                </div>
                <div className="guestlogin">
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ ascentisloginopenPopup: true });
                    }}
                  >
                    Go Back
                  </a>
                </div>
                <div className="pm-single-button">
                  <button
                    className="button"
                    id="MemberLogin"
                    onClick={this.confirmMemberLogin.bind(this)}
                  >
                    Login
                  </button>
                </div>
              </div>
            )}
            {this.state.popupType === "ascentisregister" && (
              <div className="create-account-region">
                <div className="pm-close">
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ loginopenPopup: false });
                    }}
                  >
                    <img className="close-top" src={closei} alt="close" />
                  </a>
                </div>
                <div className="sustei-reward-patenr">
                  <div className="sustei-reward">
                    <div className="msc-header">
                      <img src={susteirewards} alt="Logo" />
                      <span>REWARDS MEMBERSHIP PROGRAM</span>
                    </div>
                  </div>
                </div>
                <div className="pm-header">
                  <h4>Registration Form</h4>
                </div>
                <div className="create-account-form">
                  <div className="form-group">
                    <label className="control-label">Name*</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter First Name"
                      value={this.state.firstName}
                      onChange={this.handleChange.bind(this, "firstName")}
                    />
                    {this.state.firstNameError !== "" && (
                      <span className="error">{this.state.firstNameError}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="control-label">Password*</label>
                    <input
                      className="form-control"
                      type="password"
                      placeholder="Enter your Password*"
                      value={this.state.password}
                      onChange={this.handleChange.bind(this, "password")}
                    />
                    {this.state.passwordError !== "" && (
                      <span className="error">{this.state.passwordError}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="control-label">Confirm Password*</label>
                    <input
                      className="form-control"
                      type="password"
                      placeholder="Enter your Password*"
                      value={this.state.cpassword}
                      onChange={this.handleChange.bind(this, "cpassword")}
                    />
                    {this.state.cpasswordError !== "" && (
                      <span className="error">{this.state.cpasswordError}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="control-label">Enter your mail*</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter your mail*"
                      value={this.state.email}
                      onChange={this.handleChange.bind(this, "email")}
                    />
                    {this.state.mobileError !== "" && (
                      <span className="error">{this.state.emailError}</span>
                    )}
                  </div>

                  <div className="form-group-checkbox">
                    <span>
                      Important membership updates, member promotions and
                      account information will be sent via email.
                    </span>
                  </div>
                  <div className="form-group">
                    <label className="control-label">Gender*</label>
                    <Select
                      placeholder="Gender"
                      onChange={this.handleChangeSelect.bind(this, "gender")}
                      options={[
                        { value: "M", label: "Male" },
                        { value: "F", label: "Female" },
                        {
                          value: "O",
                          label: "Unspecified",
                        },
                      ]}
                    />
                    {this.state.genderError !== "" && (
                      <span className="error">{this.state.genderError}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <div>
                      <div className="react_datepicker">
                        <DatePicker
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText="Birthday"
                          className="form-control"
                          selected={this.state.birthdate}
                          maxDate={this.state.maxdate}
                          dateFormat="dd/MM/yyyy"
                          onChange={this.handleChangeDate}
                        />
                      </div>
                    </div>
                    {this.state.birthdateError !== "" && (
                      <span className="error">{this.state.birthdateError}</span>
                    )}
                  </div>
                    <div className="form-group">
                    <div className="seperate-mob-main">
                      <div className="seperate-mob">
                        <Select
                          placeholder="Code"
                          onChange={this.handleChangeSelect.bind(
                            this,
                            "mobilecountry"
                          )}
                          defaultValue={[
                            {
                              label: "SG | +65",
                              value: "+65",
                            },
                          ]}
                          menuIsOpen={false}
                          isDisabled={true}
                          options={[
                            {
                              label: "SG | +65",
                              value: "65",
                            },
                          ]}
                        />
                        <div className="reg-mobile">
                          <label className="control-label">
                            Mobile Number*
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Enter Mobile Number"
                            value={this.state.mobile}
                            maxLength={8}
                            onChange={this.handleChange.bind(this, "mobile")}
                          />
                          {this.state.verifiedOTP && (
                            <i class="fa fa-check-circle"></i>
                          )}
                          {this.state.mobileError !== "" && (
                            <span className="error">
                              {this.state.mobileError}
                            </span>
                          )}
                        </div>
                      </div>
                      {(this.state.showGetOTP || this.state.showResendOTP) &&
                        !this.state.verifiedOTP && (
                          <div className="member-get-opt">
                            <a
                              href="/"
                              id="member-otp"
                              onClick={this.getMemberOtp.bind(this)}
                            >
                              {this.state.showResendOTP
                                ? "Reset OTP"
                                : "Get OTP"}
                            </a>
                          </div>
                        )}
                      {this.state.showCount && (
                        <div className="member-get-opt">
                          {this.state.countTime} Sec
                        </div>
                      )}
                    </div>
                  </div>
                  {this.state.allowEnterOTP && (
                    <div className="form-group">
                      <div className="seperate-mob-main">
                        <div className="seperate-mob register-verify-otp">
                          <div>
                            <label className="control-label">OTP</label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Enter OTP"
                              value={this.state.otp}
                              maxLength={6}
                              onChange={this.handleChange.bind(this, "otp")}
                            />
                            {this.state.otpError !== "" && (
                              <span className="error">
                                {this.state.otpError}
                              </span>
                            )}
                          </div>
                          <button
                            className="button"
                            id="member-otp-verify"
                            onClick={this.verifyMemberOtp.bind(this)}
                          >
                            Verify OTP
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="form-group">
                    <label className="control-label">Nationality*</label>
                    <Select
                      placeholder="Nationality"
                      value={this.state.nationality}
                      onChange={this.handleChangeSelect.bind(
                        this,
                        "nationality"
                      )}
                      options={countryList}
                    />
                    {this.state.nationalityError !== "" && (
                      <span className="error">
                        {this.state.nationalityError}
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="control-label">Referrer Code</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter Referrer Code"
                      value={this.state.referrerCode}
                      onChange={this.handleChange.bind(this, "referrerCode")}
                    />
                  </div>
                  <div className="form-group-checkbox">
                    <input
                      type="checkbox"
                      checked={this.state.terms}
                      onChange={this.handleChange.bind(this, "terms")}
                    />
                    <span>
                      I agree to the{" "}
                      <a href="/privacy-policy" target="_blank">
                        terms & conditions
                      </a>{" "}
                    </span>
                  </div>
                  {this.state.termsError !== "" && (
                    <div>
                      <span className="error">{this.state.termsError}</span>
                    </div>
                  )}
                  <div className="form-group-checkbox">
                    <input
                      type="checkbox"
                      checked={this.state.allowPromotion}
                      onChange={this.handleChange.bind(this, "allowPromotion")}
                    />
                    <span>
                      By submitting this form, I hereby give my consent to{" "}
                      {companyName} to collect, use and disclose my personal
                      data for the purposes of processing my membership
                      application, administering my membership, as well as
                      notifying and contacting me regarding membership, sending
                      me marketing, advertising and promotional information
                      about products/services that {companyName} and its
                      affiliates may be offering, via calls, text messages, post
                      and emails. I am aware that I may update the personal data
                      and/or withdraw the consent provided by me at any time by
                      contacting {termsEmail}. The {companyName} Privacy Policy
                      and how my personal data will be used is also available
                      here
                    </span>
                  </div>
                </div>
                <div className="spacer"> </div>
                <div className="pm-single-button">
                  <button
                    className="button"
                    id="registion"
                    onClick={this.confirmMemberRegister.bind(this)}
                  >
                    Continue
                  </button>
                </div>
              </div>
            )}

            {/* Verification Popup */}
            {this.state.popupType === "otpverify" && (
              <div className="verification-region">
                <div className="pm-close">
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ loginopenPopup: false });
                    }}
                  >
                    <img className="close-top" src={closei} alt="close" />
                  </a>
                </div>
                <div className="pm-header">
                  <h4>Enter verification code</h4>
                  <span>
                    Please enter the 6-digit verification code that was sent to{" "}
                    {this.maskEmail(this.state.email)}
                  </span>
                </div>

                <div className="verfication-box-form">
                  <div className="form-group">
                    <input
                      className="form-control"
                      maxLength="1"
                      id="otp1"
                      type="text"
                      ref={this.otp1Ref}
                      value={this.state.otp1}
                      onChange={this.handleChange.bind(this, "otp1")}
                      onPasteCapture={this.onPasteCaptureHandler.bind(this)}
                      autoComplete="off"
                    />
                    <input
                      className="form-control"
                      maxLength="1"
                      id="otp2"
                      type="text"
                      ref={this.otp2Ref}
                      value={this.state.otp2}
                      onChange={this.handleChange.bind(this, "otp2")}
                      autoComplete="off"
                    />
                    <input
                      className="form-control"
                      maxLength="1"
                      id="otp3"
                      type="text"
                      ref={this.otp3Ref}
                      value={this.state.otp3}
                      onChange={this.handleChange.bind(this, "otp3")}
                      autoComplete="off"
                    />
                    <input
                      className="form-control"
                      maxLength="1"
                      id="otp4"
                      type="text"
                      ref={this.otp4Ref}
                      value={this.state.otp4}
                      onChange={this.handleChange.bind(this, "otp4")}
                      autoComplete="off"
                    />
                    <input
                      className="form-control"
                      maxLength="1"
                      id="otp5"
                      type="text"
                      ref={this.otp5Ref}
                      value={this.state.otp5}
                      onChange={this.handleChange.bind(this, "otp5")}
                      autoComplete="off"
                    />
                    <input
                      className="form-control"
                      maxLength="1"
                      id="otp6"
                      type="text"
                      ref={this.otp6Ref}
                      value={this.state.otp6}
                      onChange={this.handleChange.bind(this, "otp6")}
                      autoComplete="off"
                    />
                    {this.state.otpError !== "" && (
                      <span className="error">{this.state.otpError}</span>
                    )}
                  </div>
                  <div className="form-group-link">
                    <a href="/">I haven’t received the code </a>
                  </div>
                </div>

                <div className="pm-single-button">
                  <button
                    className="button"
                    id="verifyOTP"
                    onClick={this.confirmOTP.bind(this)}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            )}

            {/* Create Account Popup */}
            {this.state.popupType === "register" && (
              <div className="create-account-region">
                <div className="pm-close">
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ loginopenPopup: false });
                    }}
                  >
                    <img className="close-top" src={closei} alt="close" />
                  </a>
                </div>
                <div className="pm-header">
                  <h4>Create your account</h4>
                  <span>Update your informations and continue</span>
                </div>
                <div className="create-account-form">
                  <div className="form-group">
                    <label className="control-label">First Name*</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter First Name"
                      value={this.state.firstName}
                      onChange={this.handleChange.bind(this, "firstName")}
                    />
                    {this.state.firstNameError !== "" && (
                      <span className="error">{this.state.firstNameError}</span>
                    )}
                  </div>
                  {/* <div className="form-group">
                    <label className="control-label">Last Name</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter Last Name"
                      value={this.state.lastName}
                      onChange={this.handleChange.bind(this, "lastName")}
                    />
                  </div> */}
                  <div className="form-group">
                    <label className="control-label">Mobile Number*</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter Mobile Number"
                      value={this.state.mobile}
                      maxLength={8}
                      onChange={this.handleChange.bind(this, "mobile")}
                    />
                    {this.state.mobileError !== "" && (
                      <span className="error">{this.state.mobileError}</span>
                    )}
                  </div>
                  {appName==='sushitei' && (
                    <>
                    <div className="form-group">
                      <label className="control-label">Email</label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter your mail*"
                        value={this.state.email}
                        onChange={this.handleChange.bind(this, "email")}
                      />
                      {this.state.emailError !== "" && (
                        <span className="error">{this.state.emailError}</span>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="control-label">New Password</label>
                      <input
                        className="form-control"
                        type="password"
                        placeholder="Enter your new password*"
                        value={this.state.loginpassword}
                        onChange={this.handleChange.bind(this, "loginpassword")}
                      />
                      {this.state.loginpasswordError !== "" && (
                        <span className="error">{this.state.loginpasswordError}</span>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="control-label">Confirm Password</label>
                      <input
                        className="form-control"
                        type="password"
                        placeholder="Enter your confirm password*"
                        value={this.state.loginconfirmpassword}
                        onChange={this.handleChange.bind(this, "loginconfirmpassword")}
                      />
                      {this.state.loginconfirmpasswordError !== "" && (
                        <span className="error">{this.state.loginconfirmpasswordError}</span>
                      )}
                    </div>
                    </>
                  )}
                  <div className="form-group-checkbox">
                    <input
                      type="checkbox"
                      checked={this.state.terms}
                      onChange={this.handleChange.bind(this, "terms")}
                    />
                    {appName==='sushitei' ? (
                      <span>
                        I agree with {companyName}, <a href={termsEmailLink} target="_blank" rel="noreferrer">Terms & Conditions.</a>
                      </span>
                    ):(
                      <span>
                        By creating an account, I agree with the,{" "}
                        <a href="/privacy-policy" target="_blank">
                          Terms & Conditions
                        </a>{" "}
                        and the{" "}
                        <a href="/terms-and-conditions" target="_blank">
                          Privacy Policy
                        </a>
                      </span>
                    )}
                    
                  </div>
                  {this.state.termsError !== "" && (
                    <div>
                      <span className="error">{this.state.termsError}</span>
                    </div>
                  )}

                  <div className="form-group-checkbox">
                    <input
                      type="checkbox"
                      checked={this.state.allowPromotion}
                      onChange={this.handleChange.bind(this, "allowPromotion")}
                    />
                    {appName==='sushitei' ? (
                      <span>
                        By submitting this form, I hereby give my consent to{" "}
                      {companyName} to collect, use and disclose my personal
                      data for the purposes of processing my membership
                      application, administering my membership, as well as
                      notifying and contacting me regarding membership, sending
                      me marketing, advertising and promotional information
                      about products/services that {companyName} and its
                      affiliates may be offering, via calls, text messages, post
                      and emails. I am aware that I may update the personal data
                      and/or withdraw the consent provided by me at any time by
                      contacting {termsEmail}. The {companyName} Privacy Policy
                      and how my personal data will be used is also available{" "}
                      <a href={termsEmailLink} target="_blank" rel="noreferrer">here</a>
                      </span>
                    ):(
                      <span>
                      i agree to receive communications on email and phone
                    </span>
                    )}
                    
                  </div>
                  {this.state.allowPromotionError !== "" && (
                    <div>
                      <span className="error">
                        {this.state.allowPromotionError}
                      </span>
                    </div>
                  )}
                </div>
                <div className="spacer"> </div>
                <div className="pm-single-button">
                  <button
                    className="button"
                    id="registion"
                    onClick={this.confirmRegistration.bind(this)}
                  >
                    Continue
                  </button>
                </div>
              </div>
            )}
          </div>
        </Popup>
        {this.state.openomisePopup && this.state.enableOmise && (
          <OmisePayment
            openomisePopup={this.state.openomisePopup}
            updateStateValue={this.updateStateValue.bind(this)}
            payAmount={this.state.membershipAmount}
            omiseKey={this.state.omiseKey}
            enableOmise={this.state.enableOmise}
            omise_envir={this.state.omise_envir}
            processToken={this.processOmiseToken.bind(this)}
          />
        )}
        <ToastContainer autoClose={3000} />
        <AvilablityPopup
          {...this.props}
          openPopup={this.state.openAvailPopup}
          openCart={this.state.allowOpenCart}
          allowDefaultAvilablity={this.state.allowDefaultAvilablity}
          allowDefaultAvilablityName={this.state.allowDefaultAvilablityName}
          updateStateValue={this.updateStateValue.bind(this)}
        />
      </React.Fragment>
    );
  }
}

const mapStateTopProps = (state) => {
  var globalSettings = "";
  if (Object.keys(state.settings).length > 0) {
    if (state.settings[0].status === "ok") {
      globalSettings = state.settings[0].result;
    }
  }
  return {
    globalSettings: globalSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSettingDetail: () => {
      dispatch({ type: GET_GLOBAL_SETTINGS });
    },
    getStaticBlock: () => {
      dispatch({ type: GET_STATICBLOCK_LIST });
    },
    
  };
};
export default connect(
  mapStateTopProps,
  mapDispatchToProps
)(withRouter(Header));
